export const METADATA_TEMPLATES_URL = 'routing-rulesets/metadata/templates';

export enum METADATA_TEMPLATES_KEYS {
  ALL = 'all-metadata-templates',
  MAP = 'metadata-templates-map',
  TEMPLATE = 'metadata-template',
}

export const MAIN_COLUMNS = ['key'];
